import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import { MdCopyAll } from 'react-icons/md'
import { RiRepeatLine } from 'react-icons/ri'
import { MdPhotoCamera } from 'react-icons/md'
import { MdBookmarkAdd } from 'react-icons/md'
import { AiOutlineLoading } from 'react-icons/ai'
import filterString from '../../../../utils/filterString'
import styles from './SearchFinal.module.css'
import {
  selectHideIncomePrices,
  selectSearchedSpare,
  selectShowReferencePrice,
  selectHideRetailPrices,
} from '../../../../redux/searchSpares/sparesSlice'
import handleSortBy from '../../../../utils/handleSortBy'
import Loader from '../../../loader/Loader'
import { toast } from 'react-toastify'
import ModalDeliveryTimeDetails from '../../../modals/deliveryTimeDetails/ModalDeliveryTimeDetails'
import ModalOrderSpare from '../../../modals/orderSpare/ModalOrderSpare'
import ModalSaveNote from '../../../modals/saveNote/ModalSaveNote'
import { useGetOrderPermissionMutation } from '../../../../redux/clientData/apiClientData'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useGetCurrencyRatesQuery } from '../../../../redux/data/apiData'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ModalImage from '../../../modals/image/ModalImage'
import {
  useGetDeliveryTimeDetailsMutation,
  useGetSparesImageBulkMutation,
} from '../../../../redux/searchSpares/apiSearchSpares'
import { FixedSizeList } from 'react-window'

const WIDTHS = {
  brand: 9,
  code: 12,
  info: 3,
  description: 37,
  retailPrice: 5,
  price: 5,
  availability: 5,
  reserve: 5,
  supplierAvailability: 5,
  delivery: 6,
  updated: 8,
}

const HEADERWIDTHS = {
  brand: 9,
  code: 12,
  info: 3,
  description: 35,
  retailPrice: 6,
  price: 5,
  availability: 5.5,
  reserve: 4,
  supplierAvailability: 5,
  delivery: 6,
  updated: 9.5,
}

const ROW_HEIGHT = 45
const SCROLL_HEIGHT = 650

const cellStyle = (width) => ({
  width: `${width}%`,
  flexShrink: 0,
  flexGrow: 0,
  boxSizing: 'border-box',
  padding: '8px 10px 8px 5px',
  fontSize: '12px',
})

const rowContainerStyle = {
  display: 'flex',
  width: '100%',
}

const headerRowStyle = {
  display: 'flex',
  width: '100%',
  boxSizing: 'border-box',
  padding: '5px 0',
  fontWeight: 600,
  backgroundColor: '#006699',
  color: 'white',
  borderBottom: '1px solid #ccc',
}

const SearchFinal = ({
  searchFinal,
  setSearchFinal,
  handleSearchFinal,
  searchedBrand,
}) => {
  const [copied, setCopied] = useState(false)
  const [isPriceSortNeeded, setIsPriceSortNeeded] = useState(false)
  const [imageArr, setImageArr] = useState([])
  const [isSortedByBrand, setIsSortedByBrand] = useState(false)
  const [isSortedByCode, setIsSortedByCode] = useState(false)
  const [isSortedByDescription, setIsSortedByDescription] = useState(false)
  const [isSortedByRetailPrice, setIsSortedByRetailPrice] = useState(false)
  const [isSortedByPrice, setIsSortedByPrice] = useState(false)
  const [isSortedByAvailability, setIsSortedByAvailability] = useState(false)
  const [isSortedByDeliveryTime, setIsSortedByDeliveryTime] = useState(false)
  const [isNoReturnIconHovered, setIsNoReturnIconHovered] = useState(null)
  const [spareToOrder, setSpareToOrder] = useState([])
  const [isSpareToOrderInternal, setIsSpareToOrderInternal] = useState(null)
  const [imageToOpen, setImageToOpen] = useState(null)
  const [deliveryTimeDetails, setDeliveryTimeDetails] = useState(null)
  const [spareToSaveNote, setSpareToSaveNote] = useState(null)

  const searchInput = useSelector(selectSearchedSpare)
  const hideIncomePrices = useSelector(selectHideIncomePrices)
  const showReferencePrice = useSelector(selectShowReferencePrice)
  const hideRetailPrices = useSelector(selectHideRetailPrices)

  const [getOrderPermission, { isLoading: isLoadingOrderPermission }] =
    useGetOrderPermissionMutation()
  const { data: currencyRates, isLoading: isLoadingCurrencyRates } =
    useGetCurrencyRatesQuery()
  const [getDeliveryTimeDetails, { isLoading: isLoadingDeliveryTimeDetails }] =
    useGetDeliveryTimeDetailsMutation()
  const [getSpareImages, { isLoading: isLoadingImage }] =
    useGetSparesImageBulkMutation()

  const adjustedWidths = { ...WIDTHS }
  const adjustedHeaderWidths = { ...HEADERWIDTHS }

  if (showReferencePrice && !hideRetailPrices && !hideIncomePrices) {
    adjustedWidths.description = 27
    adjustedHeaderWidths.description = 26

    adjustedWidths.retailPrice = 5
    adjustedHeaderWidths.retailPrice = 5.25
    adjustedWidths.price = 5
    adjustedHeaderWidths.price = 5
    adjustedWidths.updated = 8
    adjustedHeaderWidths.updated = 8
  } else if (showReferencePrice && hideRetailPrices && !hideIncomePrices) {
    adjustedWidths.description = 35
    adjustedHeaderWidths.description = 34

    adjustedWidths.retailPrice = 5
    adjustedHeaderWidths.retailPrice = 5.5
    adjustedWidths.price = 5.5
    adjustedHeaderWidths.price = 5.5
    adjustedWidths.updated = 8
    adjustedHeaderWidths.updated = 8
  } else if (showReferencePrice && !hideRetailPrices && hideIncomePrices) {
    adjustedWidths.description = 35
    adjustedHeaderWidths.description = 33

    adjustedWidths.retailPrice = 5.5
    adjustedHeaderWidths.retailPrice = 6
    adjustedWidths.price = 5.5
    adjustedHeaderWidths.price = 5.5
    adjustedWidths.updated = 8
    adjustedHeaderWidths.updated = 8
  } else if (!showReferencePrice && hideRetailPrices && !hideIncomePrices) {
    adjustedWidths.description = 35
    adjustedHeaderWidths.description = 34

    adjustedWidths.retailPrice = 5.5
    adjustedHeaderWidths.retailPrice = 6
    adjustedWidths.price = 5.5
    adjustedHeaderWidths.price = 5.5
    adjustedWidths.updated = 8
    adjustedHeaderWidths.updated = 8
  } else if (!showReferencePrice && !hideRetailPrices && hideIncomePrices) {
    adjustedWidths.description = 35
    adjustedHeaderWidths.description = 33.5

    adjustedWidths.retailPrice = 5.5
    adjustedHeaderWidths.retailPrice = 6
    adjustedWidths.price = 5.5
    adjustedHeaderWidths.price = 5.5
    adjustedWidths.updated = 8
    adjustedHeaderWidths.updated = 8
  }

  async function updatePhotoUrls(spares) {
    const filteredSpares = spares.map((spare) => ({
      brand: spare.brand,
      code: spare.code,
    }))
    try {
      const updatedSpares = await getSpareImages({
        spares: filteredSpares,
      }).unwrap()
      return updatedSpares
    } catch (error) {
      console.error(error)
      return spares
    }
  }

  const getPhotoUrl = (brand, code) => {
    const found = imageArr.find(
      (item) =>
        filterString(item.brand) === filterString(brand) &&
        filterString(item.code) === filterString(code)
    )
    return found ? found.photoUrl : null
  }

  const handleGetDeliveryTimeDetails = async (spareID) => {
    try {
      const response = await getDeliveryTimeDetails({ spareID }).unwrap()
      if (
        response?.supplierOrderInformation !== null &&
        response?.supplierDeliveryInformation !== null
      ) {
        setDeliveryTimeDetails(response)
      } else {
        toast.error('Немає деталей доставки...')
      }
    } catch (error) {
      if (error.data.message === 'No delivery time details') {
        toast.error('Немає деталей доставки...')
      } else {
        toast.error('Сталась помилка...')
      }
    }
  }

  useEffect(() => {
    async function fetchImagesForSpares() {
      const updatedSpares = await updatePhotoUrls(searchFinal)
      setImageArr(updatedSpares)
    }
    fetchImagesForSpares()
  }, [searchFinal])

  const compareInput = (input, code, availability) => {
    const filteredInput = filterString(input)
    const filteredCode = filterString(code)
    return filteredInput === filteredCode ? availability > 0 : false
  }

  const checkAvailability = (availability, reserve) =>
    availability > 0 || reserve > 0
  const checkReserve = (availability, reserve) =>
    availability === 0 && reserve > 0
  const checkSelectedSupplierBrand = (
    availability,
    reserve,
    code,
    supplierAvailability,
    brand
  ) =>
    !(availability > 0) &&
    !(reserve > 0) &&
    parseInt(supplierAvailability, 10) !== 0 &&
    filterString(code) === searchInput &&
    filterString(brand) === filterString(searchedBrand)
  const checkSupplierBrand = (
    availability,
    reserve,
    code,
    supplierAvailability,
    brand
  ) =>
    !(availability > 0) &&
    !(reserve > 0) &&
    parseInt(supplierAvailability, 10) !== 0 &&
    !(
      filterString(code) === searchInput &&
      filterString(brand) === filterString(searchedBrand)
    )

  const handleOrderSpare = async (
    brand,
    code,
    availability,
    price,
    spareID,
    isInternal,
    supplierAvailability = null,
    isReturnable = true
  ) => {
    const orderPermission = await getOrderPermission().unwrap()
    if (orderPermission === false) {
      toast.error('Немає прав на замовлення, зверніться до вашого менеджера...')
      return
    }
    if (brand && code && availability && price && isInternal) {
      const spare = { brand, code, availability, price, spareID, isReturnable }
      setIsSpareToOrderInternal(isInternal)
      setSpareToOrder([spare])
    } else if (brand && code && supplierAvailability && price && !isInternal) {
      const spare = {
        brand,
        code,
        availability: 1000,
        price,
        spareID,
        supplierAvailability: null,
        isReturnable,
      }
      setIsSpareToOrderInternal(isInternal)
      setSpareToOrder([spare])
    } else {
      toast.error('Неможливо замовити запчастину...')
    }
  }

  const onCopy = (text, result) => {
    setCopied(result)
    if (result) {
      toast.success('Артикул скопійовано')
    } else {
      toast.error('Не вдалося скопіювати артикул')
    }
  }

  const specialBrands = ['michelin', 'spidan', 'et1eco', 'eligran']
  const optimalBrands = ['rpm8t']

  const availableParts = searchFinal.filter((el) =>
    checkAvailability(el.availability, el.reserve)
  )
  const selectedSupplierParts = searchFinal.filter((el) =>
    checkSelectedSupplierBrand(
      el.availability,
      el.reserve,
      el.code,
      el.supplierAvailability,
      el.brand
    )
  )
  const supplierParts = searchFinal.filter((el) =>
    checkSupplierBrand(
      el.availability,
      el.reserve,
      el.code,
      el.supplierAvailability,
      el.brand
    )
  )

  const DescriptionCell = ({ description, className, style }) => {
    const descriptionRef = useRef(null)
    const [isOverflowing, setIsOverflowing] = useState(false)
    const tooltipId = 'description-tooltip'

    useEffect(() => {
      const checkOverflow = () => {
        if (descriptionRef.current) {
          const element = descriptionRef.current
          const isOverflow = element.scrollWidth > element.clientWidth
          setIsOverflowing(isOverflow)
        }
      }

      checkOverflow()
      // Проверяем также после небольшой задержки, чтобы убедиться, что элемент полностью отрендерился
      const timeoutId = setTimeout(checkOverflow, 0)
      
      return () => clearTimeout(timeoutId)
    }, [description])

    return (
      <div
        ref={descriptionRef}
        style={style}
        className={className}
        data-tooltip-id={isOverflowing ? tooltipId : undefined}
        data-tooltip-content={isOverflowing ? description : undefined}
        data-tooltip-place="bottom"
      >
        {description}
      </div>
    )
  }

  const HeaderRow = () => (
    <div style={headerRowStyle}>
      <div
        style={cellStyle(adjustedHeaderWidths.brand)}
        onClick={() =>
          handleSortBy(
            searchFinal,
            'brand',
            isSortedByBrand,
            setIsSortedByBrand,
            setSearchFinal
          )
        }
      >
        Бренд
      </div>
      <div
        style={cellStyle(adjustedHeaderWidths.code)}
        onClick={() =>
          handleSortBy(
            searchFinal,
            'code',
            isSortedByCode,
            setIsSortedByCode,
            setSearchFinal
          )
        }
      >
        Номер
      </div>
      <div style={cellStyle(adjustedHeaderWidths.info)}>Фото</div>
      <div
        style={cellStyle(adjustedHeaderWidths.description)}
        onClick={() =>
          handleSortBy(
            searchFinal,
            'description',
            isSortedByDescription,
            setIsSortedByDescription,
            setSearchFinal
          )
        }
      >
        Опис
      </div>
      {!hideRetailPrices && (
        <div
          style={cellStyle(adjustedHeaderWidths.retailPrice)}
          onClick={() =>
            handleSortBy(
              searchFinal,
              'retailPrice',
              isSortedByRetailPrice,
              setIsSortedByRetailPrice,
              setSearchFinal
            )
          }
        >
          Роздріб
        </div>
      )}
      {!hideRetailPrices && showReferencePrice && (
        <div
          style={cellStyle(adjustedHeaderWidths.retailPrice)}
          onClick={() =>
            handleSortBy(
              searchFinal,
              'retailPrice',
              isSortedByPrice,
              setIsSortedByPrice,
              setSearchFinal
            )
          }
        >
          Роздріб
        </div>
      )}
      {!hideIncomePrices && (
        <div
          style={cellStyle(adjustedHeaderWidths.price)}
          onClick={() =>
            handleSortBy(
              searchFinal,
              'price',
              isSortedByPrice,
              setIsSortedByPrice,
              setSearchFinal
            )
          }
        >
          Ціна
        </div>
      )}
      {!hideIncomePrices && showReferencePrice && (
        <div
          style={cellStyle(adjustedHeaderWidths.price)}
          onClick={() =>
            handleSortBy(
              searchFinal,
              'price',
              isSortedByPrice,
              setIsSortedByPrice,
              setSearchFinal
            )
          }
        >
          Ціна
        </div>
      )}
      <div
        style={cellStyle(adjustedHeaderWidths.availability)}
        onClick={() =>
          handleSortBy(
            searchFinal,
            'availability',
            isSortedByAvailability,
            setIsSortedByAvailability,
            setSearchFinal
          )
        }
      >
        Наявність
      </div>
      <div style={cellStyle(adjustedHeaderWidths.reserve)}>Резерв</div>
      <div style={cellStyle(adjustedHeaderWidths.supplierAvailability)}>
        Заказ
      </div>
      <div
        style={cellStyle(adjustedHeaderWidths.delivery)}
        onClick={() =>
          handleSortBy(
            searchFinal,
            'deliveryTime',
            isSortedByDeliveryTime,
            setIsSortedByDeliveryTime,
            setSearchFinal
          )
        }
      >
        Термін
      </div>
      <div style={cellStyle(adjustedHeaderWidths.updated)}>Оновлено</div>
    </div>
  )

  const RowAvailable = ({ index, style, data }) => {
    const el = data[index]
    return (
      <div
        style={{ ...style, ...rowContainerStyle }}
        className={`${
          compareInput(searchInput, el.code, el.availability)
            ? styles.selectedSpareTr
            : styles.spareTr
        } ${
          checkReserve(el.availability, el.reserve)
            ? styles.tableRowReserved
            : specialBrands.includes(filterString(el.brand))
            ? styles.tableRowSpecial
            : optimalBrands.includes(filterString(el.brand))
            ? styles.tableRowOptimal
            : styles.tableRow
        }`}
        data-tooltip-id="tooltip"
        data-tooltip-content={
          specialBrands.includes(filterString(el.brand))
            ? `Додатковий заробіток: ${(el.retailPrice - el.price).toFixed(
                2
              )} (${((el.retailPrice / el.price - 1) * 100).toFixed(2)}%)`
            : `Заробіток: ${(el.retailPrice - el.price).toFixed(2)} (${(
                (el.retailPrice / el.price - 1) *
                100
              ).toFixed(2)}%)`
        }
        onClick={() =>
          handleOrderSpare(
            el.brand,
            el.code,
            el.availability,
            el.price,
            el.spareID,
            true,
            el.supplierAvailability
          )
        }
      >
        <div
          style={cellStyle(adjustedWidths.brand)}
          className={
            checkReserve(el.availability, el.reserve)
              ? styles.tableRowReserved
              : specialBrands.includes(filterString(el.brand))
              ? styles.tableRowSpecial
              : optimalBrands.includes(filterString(el.brand))
              ? styles.tableRowOptimal
              : styles.tableRow
          }
        >
          {el.brand}
        </div>
        <div
          style={cellStyle(adjustedWidths.code)}
          className={
            checkReserve(el.availability, el.reserve)
              ? styles.tableRowReserved
              : specialBrands.includes(filterString(el.brand))
              ? styles.tableRowSpecial
              : optimalBrands.includes(filterString(el.brand))
              ? styles.tableRowOptimal
              : styles.tableRow
          }
        >
          {el.code}
          <CopyToClipboard text={el.code} onCopy={onCopy}>
            <span
              onClick={(e) => e.stopPropagation()}
              className={styles.copyIconSpan}
            >
              <MdCopyAll />
            </span>
          </CopyToClipboard>
          <span
            onClick={(e) => {
              e.stopPropagation()
              setSpareToSaveNote({
                spareID: el.spareID,
                brand: el.brand,
                code: el.code,
                description: el.description,
              })
            }}
            className={styles.copyIconSpan}
            title="Зберегти в нотатки"
          >
            <MdBookmarkAdd />
          </span>
        </div>
        <div
          style={cellStyle(adjustedWidths.info)}
          className={
            checkReserve(el.availability, el.reserve)
              ? styles.tableRowReserved
              : specialBrands.includes(filterString(el.brand))
              ? styles.tableRowSpecial
              : optimalBrands.includes(filterString(el.brand))
              ? styles.tableRowOptimal
              : styles.tableRow
          }
          onClick={(e) => {
            e.stopPropagation()
            setImageToOpen(getPhotoUrl(el.brand, el.code))
          }}
        >
          <span className={styles.imageWrapper}>
            {isLoadingImage ? (
              <span className={styles.imageIcon}>
                <AiOutlineLoading className={styles.loadingIcon} />
              </span>
            ) : getPhotoUrl(el.brand, el.code) ? (
              <MdPhotoCamera className={styles.imageIcon} />
            ) : (
              <span className={styles.imagePlaceholder}></span>
            )}
          </span>
        </div>
        <DescriptionCell
          description={el.description}
          style={cellStyle(adjustedWidths.description)}
          className={
            checkReserve(el.availability, el.reserve)
              ? styles.tableRowReserved
              : specialBrands.includes(filterString(el.brand))
              ? styles.tableRowSpecial
              : optimalBrands.includes(filterString(el.brand))
              ? styles.tableRowOptimal
              : styles.tableRow
          }
        />
        {!hideRetailPrices && (
          <div
            style={cellStyle(adjustedWidths.retailPrice)}
            className={
              checkReserve(el.availability, el.reserve)
                ? styles.tableRowReserved
                : specialBrands.includes(filterString(el.brand))
                ? styles.tableRowSpecial
                : optimalBrands.includes(filterString(el.brand))
                ? styles.tableRowOptimal
                : styles.tableRow
            }
          >
            {el.retailPrice}
          </div>
        )}
        {!hideRetailPrices && showReferencePrice && (
          <div
            style={cellStyle(adjustedWidths.retailPrice)}
            className={
              checkReserve(el.availability, el.reserve)
                ? styles.tableRowReserved
                : specialBrands.includes(filterString(el.brand))
                ? styles.tableRowSpecial
                : optimalBrands.includes(filterString(el.brand))
                ? styles.tableRowOptimal
                : styles.tableRow
            }
          >
            {(el.retailPrice * currencyRates?.eur).toFixed(2)}
          </div>
        )}
        {!hideIncomePrices && (
          <div
            style={cellStyle(adjustedWidths.price)}
            className={
              checkReserve(el.availability, el.reserve)
                ? styles.tableRowReserved
                : specialBrands.includes(filterString(el.brand))
                ? styles.tableRowSpecial
                : optimalBrands.includes(filterString(el.brand))
                ? styles.tableRowOptimal
                : styles.tableRow
            }
          >
            {el.price}
          </div>
        )}
        {!hideIncomePrices && showReferencePrice && (
          <div
            style={cellStyle(adjustedWidths.price)}
            className={
              checkReserve(el.availability, el.reserve)
                ? styles.tableRowReserved
                : specialBrands.includes(filterString(el.brand))
                ? styles.tableRowSpecial
                : optimalBrands.includes(filterString(el.brand))
                ? styles.tableRowOptimal
                : styles.tableRow
            }
          >
            {(el.price * currencyRates?.eur).toFixed(2)}
          </div>
        )}
        <div
          style={cellStyle(adjustedWidths.availability)}
          className={
            checkReserve(el.availability, el.reserve)
              ? styles.tableRowAvailabilityReserved
              : specialBrands.includes(filterString(el.brand))
              ? styles.tableRowSpecialAvailability
              : optimalBrands.includes(filterString(el.brand))
              ? styles.tableRowOptimalAvailability
              : styles.tableRowAvailability
          }
        >
          {el.availability > 0 && el.availability > 10
            ? '10+'
            : el.availability}
        </div>
        <div
          style={cellStyle(adjustedWidths.reserve)}
          className={
            checkReserve(el.availability, el.reserve)
              ? styles.tableRowAvailabilityReserved
              : specialBrands.includes(filterString(el.brand))
              ? styles.tableRowSpecialAvailability
              : optimalBrands.includes(filterString(el.brand))
              ? styles.tableRowOptimalAvailability
              : styles.tableRowAvailability
          }
        >
          {el.reserve > 0 && el.reserve}
        </div>
        <div
          style={cellStyle(adjustedWidths.supplierAvailability)}
          className={
            checkReserve(el.availability, el.reserve)
              ? styles.tableRowReserved
              : specialBrands.includes(filterString(el.brand))
              ? styles.tableRowSpecial
              : optimalBrands.includes(filterString(el.brand))
              ? styles.tableRowOptimal
              : styles.tableRow
          }
        >
          {el.supplierAvailability > 0 && el.supplierAvailability}
        </div>
        <div
          style={cellStyle(adjustedWidths.delivery)}
          className={
            checkReserve(el.availability, el.reserve)
              ? styles.tableRowReserved
              : specialBrands.includes(filterString(el.brand))
              ? styles.tableRowSpecial
              : optimalBrands.includes(filterString(el.brand))
              ? styles.tableRowOptimal
              : styles.tableRow
          }
        >
          {el.deliveryTime}
        </div>
        <div
          style={cellStyle(adjustedWidths.updated)}
          className={
            checkReserve(el.availability, el.reserve)
              ? styles.tableRowReserved
              : specialBrands.includes(filterString(el.brand))
              ? styles.tableRowSpecial
              : optimalBrands.includes(filterString(el.brand))
              ? styles.tableRowOptimal
              : styles.tableRow
          }
        >
          {el.updateDate}
        </div>
      </div>
    )
  }

  const RowSelectedSupplier = ({ index, style, data }) => {
    const el = data[index]
    return (
      <div
        style={{ ...style, ...rowContainerStyle }}
        className={styles.tableRowWrapperSupplierSelected}
        onClick={() =>
          handleOrderSpare(
            el.brand,
            el.code,
            el.availability,
            el.price,
            el.spareID,
            false,
            el.supplierAvailability,
            el.returnable
          )
        }
      >
        <div
          style={cellStyle(adjustedWidths.brand)}
          className={styles.tableRowSupplierSelected}
        >
          {el.brand}
        </div>
        <div
          style={cellStyle(adjustedWidths.code)}
          className={styles.tableRowSupplierSelected}
        >
          {el.code}
          <CopyToClipboard text={el.code} onCopy={onCopy}>
            <span
              onClick={(e) => e.stopPropagation()}
              className={styles.copyIconSpan}
            >
              <MdCopyAll />
            </span>
          </CopyToClipboard>
          <span
            onClick={(e) => {
              e.stopPropagation()
              setSpareToSaveNote({
                spareID: el.spareID,
                brand: el.brand,
                code: el.code,
                description: el.description,
              })
            }}
            className={styles.copyIconSpan}
            title="Зберегти в нотатки"
          >
            <MdBookmarkAdd />
          </span>
        </div>
        <div
          style={cellStyle(adjustedWidths.info)}
          className={styles.tableRowSupplierSelected}
          onClick={(e) => {
            e.stopPropagation()
            setImageToOpen(getPhotoUrl(el.brand, el.code))
          }}
        >
          <span className={styles.imageWrapper}>
            {isLoadingImage ? (
              <span className={styles.imageIcon}>
                <AiOutlineLoading className={styles.loadingIcon} />
              </span>
            ) : getPhotoUrl(el.brand, el.code) ? (
              <MdPhotoCamera className={styles.imageIcon} />
            ) : (
              <span className={styles.imagePlaceholder}></span>
            )}
          </span>
        </div>
        <DescriptionCell
          description={el.description}
          style={cellStyle(adjustedWidths.description)}
          className={styles.tableRowSupplierSelected}
        />
        {!hideRetailPrices && (
          <div
            style={cellStyle(adjustedWidths.retailPrice)}
            className={styles.tableRowSupplierSelected}
          >
            {el.retailPrice}
          </div>
        )}
        {!hideRetailPrices && showReferencePrice && (
          <div
            style={cellStyle(adjustedWidths.retailPrice)}
            className={styles.tableRowSupplierSelected}
          >
            {(el.retailPrice * currencyRates?.eur).toFixed(2)}
          </div>
        )}
        {!hideIncomePrices && (
          <div
            style={cellStyle(adjustedWidths.price)}
            className={styles.tableRowSupplierSelected}
          >
            {el.price}
          </div>
        )}
        {!hideIncomePrices && showReferencePrice && (
          <div
            style={cellStyle(adjustedWidths.price)}
            className={styles.tableRowSupplierSelected}
          >
            {(el.price * currencyRates?.eur).toFixed(2)}
          </div>
        )}
        <div
          style={cellStyle(adjustedWidths.availability)}
          className={styles.tableRowSupplierSelected}
        >
          {el.availability > 0 && el.availability}
        </div>
        <div
          style={cellStyle(adjustedWidths.reserve)}
          className={styles.tableRowSupplierSelected}
        >
          {!el.returnable && (
            <span className={styles.imageWrapper}>
              <RiRepeatLine
                onMouseEnter={() => setIsNoReturnIconHovered(index)}
                onMouseLeave={() => setIsNoReturnIconHovered(null)}
                className={styles.noReturnIcon}
              />
            </span>
          )}
          {isNoReturnIconHovered === index && (
            <span className={styles.noReturnTextContainer}>
              Не підлягає поверненню
            </span>
          )}
        </div>
        <div
          style={cellStyle(adjustedWidths.supplierAvailability)}
          className={styles.tableRowSupplierSelected}
        >
          {el.supplierAvailability}
        </div>
        <div
          style={cellStyle(adjustedWidths.delivery)}
          className={
            el.isDeliveryTimeReliable
              ? styles.deliveryTimeReliable
              : styles.tableRowSupplierSelected
          }
          onClick={(e) => {
            e.stopPropagation()
            handleGetDeliveryTimeDetails(el.spareID)
          }}
        >
          <span>{el.deliveryTime} дн.</span>
        </div>
        <div
          style={cellStyle(adjustedWidths.updated)}
          className={styles.tableRowSupplierSelected}
        >
          {el.updateDate}
        </div>
      </div>
    )
  }

  const RowSupplierAnalog = ({ index, style, data }) => {
    const el = data[index]
    return (
      <div
        style={{ ...style, ...rowContainerStyle }}
        className={styles.tableRowWrapperSupplierSelected}
        onClick={() =>
          handleOrderSpare(
            el.brand,
            el.code,
            el.availability,
            el.price,
            el.spareID,
            false,
            el.supplierAvailability,
            el.returnable
          )
        }
      >
        <div
          style={cellStyle(adjustedWidths.brand)}
          className={styles.tableRowSupplierSelected}
        >
          {el.brand}
        </div>
        <div
          style={cellStyle(adjustedWidths.code)}
          className={styles.tableRowSupplierSelected}
        >
          {el.code}
          <CopyToClipboard text={el.code} onCopy={onCopy}>
            <span
              onClick={(e) => e.stopPropagation()}
              className={styles.copyIconSpan}
            >
              <MdCopyAll />
            </span>
          </CopyToClipboard>
          <span
            onClick={(e) => {
              e.stopPropagation()
              setSpareToSaveNote({
                spareID: el.spareID,
                brand: el.brand,
                code: el.code,
                description: el.description,
              })
            }}
            className={styles.copyIconSpan}
            title="Зберегти в нотатки"
          >
            <MdBookmarkAdd />
          </span>
        </div>
        <div
          style={cellStyle(adjustedWidths.info)}
          className={styles.tableRowSupplierSelected}
          onClick={(e) => {
            e.stopPropagation()
            setImageToOpen(getPhotoUrl(el.brand, el.code))
          }}
        >
          <span className={styles.imageWrapper}>
            {isLoadingImage ? (
              <span className={styles.imageIcon}>
                <AiOutlineLoading className={styles.loadingIcon} />
              </span>
            ) : getPhotoUrl(el.brand, el.code) ? (
              <MdPhotoCamera className={styles.imageIcon} />
            ) : (
              <span className={styles.imagePlaceholder}></span>
            )}
          </span>
        </div>
        <DescriptionCell
          description={el.description}
          style={cellStyle(adjustedWidths.description)}
          className={styles.tableRowSupplierSelected}
        />
        {!hideRetailPrices && (
          <div
            style={cellStyle(adjustedWidths.retailPrice)}
            className={styles.tableRowSupplierSelected}
          >
            {el.retailPrice}
          </div>
        )}
        {!hideRetailPrices && showReferencePrice && (
          <div
            style={cellStyle(adjustedWidths.retailPrice)}
            className={styles.tableRowSupplierSelected}
          >
            {(el.retailPrice * currencyRates?.eur).toFixed(2)}
          </div>
        )}
        {!hideIncomePrices && (
          <div
            style={cellStyle(adjustedWidths.price)}
            className={styles.tableRowSupplierSelected}
          >
            {el.price}
          </div>
        )}
        {!hideIncomePrices && showReferencePrice && (
          <div
            style={cellStyle(adjustedWidths.price)}
            className={styles.tableRowSupplierSelected}
          >
            {(el.price * currencyRates?.eur).toFixed(2)}
          </div>
        )}
        <div
          style={cellStyle(adjustedWidths.availability)}
          className={styles.tableRowSupplierSelected}
        >
          {el.availability > 0 && el.availability}
        </div>
        <div
          style={cellStyle(adjustedWidths.reserve)}
          className={styles.tableRowSupplierSelected}
        >
          {!el.returnable && (
            <span className={styles.imageWrapper}>
              <RiRepeatLine
                onMouseEnter={() => setIsNoReturnIconHovered(index)}
                onMouseLeave={() => setIsNoReturnIconHovered(null)}
                className={styles.noReturnIcon}
              />
            </span>
          )}
          {isNoReturnIconHovered === index && (
            <span className={styles.noReturnTextContainer}>
              Не підлягає поверненню
            </span>
          )}
        </div>
        <div
          style={cellStyle(adjustedWidths.supplierAvailability)}
          className={styles.tableRowSupplierSelected}
        >
          {el.supplierAvailability}
        </div>
        <div
          style={cellStyle(adjustedWidths.delivery)}
          className={
            el.isDeliveryTimeReliable
              ? styles.deliveryTimeReliable
              : styles.tableRowSupplierSelected
          }
          onClick={(e) => {
            e.stopPropagation()
            handleGetDeliveryTimeDetails(el.spareID)
          }}
        >
          <span>{el.deliveryTime} дн.</span>
        </div>
        <div
          style={cellStyle(adjustedWidths.updated)}
          className={styles.tableRowSupplierSelected}
        >
          {el.updateDate}
        </div>
      </div>
    )
  }

  return (
    <>
      {deliveryTimeDetails &&
        deliveryTimeDetails?.supplierOrderInformation &&
        deliveryTimeDetails?.supplierDeliveryInformation && (
          <ModalDeliveryTimeDetails
            setDeliveryTimeDetails={setDeliveryTimeDetails}
            deliveryTimeDetails={deliveryTimeDetails}
          />
        )}
      {spareToOrder.length > 0 && (
        <ModalOrderSpare
          setSpareToOrder={setSpareToOrder}
          spareToOrder={spareToOrder}
          handleSearchFinal={handleSearchFinal}
          isSpareToOrderInternal={isSpareToOrderInternal}
          setIsPriceSortNeeded={setIsPriceSortNeeded}
          isPriceSortNeeded={isPriceSortNeeded}
        />
      )}
      {imageToOpen && (
        <ModalImage imageToOpen={imageToOpen} setImageToOpen={setImageToOpen} />
      )}
      {spareToSaveNote && (
        <ModalSaveNote spare={spareToSaveNote} setSpare={setSpareToSaveNote} />
      )}
      {isLoadingOrderPermission && <Loader />}
      {isLoadingCurrencyRates && <Loader />}
      {isLoadingDeliveryTimeDetails && <Loader />}

      {availableParts.length > 0 && (
        <div className={styles.sectionWrapper} style={{ width: '100%' }}>
          <h4>Наявність на складі</h4>
          <HeaderRow />
          <div style={{ width: '100%' }}>
            <FixedSizeList
              height={Math.min(
                SCROLL_HEIGHT,
                availableParts.length * ROW_HEIGHT
              )}
              itemCount={availableParts.length}
              itemSize={ROW_HEIGHT}
              width="100%"
              itemData={availableParts}
            >
              {RowAvailable}
            </FixedSizeList>
            <Tooltip id="tooltip" />
          </div>
        </div>
      )}

      {selectedSupplierParts.length > 0 && (
        <>
          <h4>Запрошений артикул</h4>
          <div
            className={styles.sectionWrapper}
            style={{ width: '100%', backgroundColor: 'lightyellow' }}
          >
            <HeaderRow />
            <div style={{ width: '100%' }}>
              <FixedSizeList
                height={Math.min(
                  SCROLL_HEIGHT,
                  selectedSupplierParts.length * ROW_HEIGHT
                )}
                itemCount={selectedSupplierParts.length}
                itemSize={ROW_HEIGHT}
                width="100%"
                itemData={selectedSupplierParts}
              >
                {RowSelectedSupplier}
              </FixedSizeList>
            </div>
          </div>
        </>
      )}

      {supplierParts.length > 0 && (
        <div className={styles.sectionWrapper} style={{ width: '100%' }}>
          <h4>Аналоги</h4>
          <HeaderRow />
          <div style={{ width: '100%' }}>
            <FixedSizeList
              height={Math.min(
                SCROLL_HEIGHT,
                supplierParts.length * ROW_HEIGHT
              )}
              itemCount={supplierParts.length}
              itemSize={ROW_HEIGHT}
              width="100%"
              itemData={supplierParts}
            >
              {RowSupplierAnalog}
            </FixedSizeList>
          </div>
        </div>
      )}
      <Tooltip id="description-tooltip" place="bottom" />
    </>
  )
}

export default SearchFinal
